import { ref, reactive, toRefs, onMounted } from "vue";
import * as echarts from "echarts";
import DataCard from './components/DataCard.vue';
import apis from "@/api";
export default {
  name: "DataCenterModule",
  components: {
    DataCard
  },
  setup() {
    const data = reactive({
      chartContain: ref(),
      myChart: "",
      chartOption: {
        //矩形树配置信息
        color: ["#33ccff", "#0066ff", "#32CD32", "#EEC900", "#FFC0CB", "#EEB422"],
        grid: {
          top: 0,
          bottom: 0
        },
        toolbox: {
          show: false
        },
        title: {
          show: false
        },
        series: [{
          name: "各素材占比",
          type: "treemap",
          data: [{
            name: "图片",
            value: 0
          }, {
            name: "文本",
            value: 0
          }, {
            name: "短信",
            value: 0
          }, {
            name: "音频",
            value: 0
          }, {
            name: "视频",
            value: 0
          }, {
            name: "其它",
            value: 0
          }]
        }]
      },
      sumData: {
        //素材总数量
        count: 0,
        day: {
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      onLineData: {
        //在途的素材
        count: 0,
        day: {
          //素材总数量
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      deviseData: {
        //待入库的设计素材
        count: 0,
        day: {
          //素材总数量
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      shortMsgData: {
        //待入库的短信素材
        count: 0,
        day: {
          //素材总数量
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      lineDemand: {
        //在途设计需求
        count: 0,
        day: {
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      noCheckDemand: {
        //待审核需求
        count: 0,
        day: {
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      deviseDemand: {
        //进行中的设计需求
        count: 0,
        day: {
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      invalidData: {
        //失效的素材
        count: 0,
        day: {
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      suspendData: {
        //挂起的素材
        count: 0,
        day: {
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      closeDemand: {
        //已关闭的需求
        count: 0,
        day: {
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      },
      accomplishDemand: {
        //已完成的需求
        count: 0,
        day: {
          count: 0,
          inr: true,
          proportion: "0%"
        },
        week: {
          count: 0,
          inr: true,
          proportion: "0%"
        }
      }
    });

    //矩形树
    const chartInit = () => {
      data.myChart = echarts.init(data.chartContain);
      data.myChart.setOption(data.chartOption);
    };

    //素材总数量查询
    const doLoadAssetsData = () => {
      apis.loadAssetsData().then(res => {
        if (res.success) {
          let resultData = res.data;
          updateChartOption(resultData.seriesData);
          data.sumData = resultData.sumData;
          data.onLineData = resultData.onLineData;
          data.deviseData = resultData.deviseData;
          data.shortMsgData = resultData.shortMsgData;
          data.lineDemand = resultData.lineDemand;
          data.noCheckDemand = resultData.noCheckDemand;
          data.deviseDemand = resultData.deviseDemand;
          data.invalidData = resultData.invalidData;
          data.suspendData = resultData.suspendData;
          data.closeDemand = resultData.closeDemand;
          data.accomplishDemand = resultData.accomplishDemand;
        }
      });
    };
    const updateChartOption = val => {
      const seriesData = ref(data.chartOption.series[0].data);
      seriesData.value[0].name = seriesData.value[0].name + "\n" + val.image + "(" + val.imagePro + ")";
      seriesData.value[0].value = val.image;
      seriesData.value[1].name = seriesData.value[1].name + "\n" + val.text + "(" + val.textPro + ")";
      seriesData.value[1].value = val.text;
      seriesData.value[2].name = seriesData.value[2].name + "\n" + val.shortMsg + "(" + val.shortMsgPro + ")";
      seriesData.value[2].value = val.shortMsg;
      seriesData.value[3].name = seriesData.value[3].name + "\n" + val.audio + "(" + val.audioPro + ")";
      seriesData.value[3].value = val.audio;
      seriesData.value[4].name = seriesData.value[4].name + "\n" + val.video + "(" + val.videoPro + ")";
      seriesData.value[4].value = val.video;
      seriesData.value[5].name = seriesData.value[4].name + "\n" + val.otherCount + "(" + val.otherPro + ")";
      seriesData.value[5].value = val.votherCount;
      data.myChart.setOption(data.chartOption);
    };
    onMounted(() => {
      doLoadAssetsData();
      chartInit();
    });
    return {
      ...toRefs(data),
      chartInit,
      doLoadAssetsData,
      updateChartOption
    };
  }
};